import axios from 'axios';

async function validatePostalCodeRequest(countryID, postalCode, cancelToken) {
  try {
    const res = await axios.post(
      `/validatePostalCode?countryID=${countryID}&postalCode=${postalCode}`,
      {},
      { cancelToken }
    );
    return res.data;
  } catch (err) {
    if (axios.isCancel(err)) {
      console.log('Request canceled', err.message);
    } else {
      console.error(err);
      throw err;
    }
  }
}

export default validatePostalCodeRequest;
